import { render } from "./ChatMessage.vue?vue&type=template&id=558c7378&scoped=true&ts=true"
import script from "./ChatMessage.vue?vue&type=script&lang=ts"
export * from "./ChatMessage.vue?vue&type=script&lang=ts"

import "./ChatMessage.vue?vue&type=style&index=0&id=558c7378&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-558c7378"]])

export default __exports__